var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJasminegreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    "data-name": "Layer 7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.9 421.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b2b1b2;\n        stroke: #b2b1b2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #545554;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #535453;\n      }\n\n      .cls-3 {\n        fill: #545453;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #555;\n        stroke: #555;\n      }\n\n      .cls-6 {\n        fill: #e9e9e9;\n        stroke: #e9e9e9;\n      }\n\n      .cls-7 {\n        fill: #717272;\n        stroke: #717272;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_Mirror",
    "data-name": "Color Mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.26,259.06l-5.49-29.42-8.86-4.48-23.98-.17-4.17-18.1-31.06-13.35,4.67-11.78,14.83.44,7.16,1.97-5.77-14.88,11.75-22.35,14.58-13.8-2.24-12.46-11.77-12.22-7.4-7.43,7.17-17.44-1.12-8.88-4.6-7.62.34-24.38-15.47-11.15-11.44-4.6s-10.76-17.15-14.35-18.05c-3.59-.9-24.66-7.29-31.5-7.4-6.84-.11-34.87,6.39-39.35,8.41s-22.65,21.19-22.65,21.19l-17.44,33.8-3.07.17,1.91,7.06s-6.17,5.27-5.04,8.52c1.12,3.25,7.6,15.51,6.21,22.98l27.76,19.21-2,30.79,13.25,30.44-29.06,6v-7l-24.32-5.76-6.85-.24,12.3,11.01,4.93,5.17,1.01,4.34,7.82,9.29-8.84,20.67-37.05,3.38-4.33,32.28,14.1,62.71,20.49,61.89,171.83,3.93,12.89-33.52,5.04-17.6,3.3-2.58-3.18-3.83,3.18-6.8,5.67-1.25,4.15-13.68-5.25-3.83,3.39-7.06,3.77,1.14,1.25-9.35-3.15-2.42,6.05-31.9h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.89,283.76s3.69-6.18,3.14-11.28-3.04-27.33-5.64-29.28-6.61-5.05-6.51-6.81c0,0,4.5.73,6.1.74s12.02,5.2,12.02,5.2l4.2,36.22-13.32,5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.03,233.23s3.62-3.5,1.22-6.38c-2.39-2.88-22.98,1.54-22.98,1.54,0,0-12.54,2.16-14.01,4.85s-1.99,2.69-1.99,2.69c0,0,.24-4.69,5.17-9.4,0,0,19.04-6.24,19.15-10.29s-7.08-12.69-7.08-12.69l10.25-10.29,21.78,22.76-3.9,13.39-7.61,3.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.52,274.45c5.05-1.48-.2-4.79-1.63-4.79,0,0-3.73,4.67-6.75,4.59s0,11.07,0,11.07c0,0,4.59-9.76,8.37-10.87h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.41,283.76s-3.69-6.18-3.14-11.28,3.04-27.33,5.64-29.28,6.61-5.05,6.51-6.81c0,0-4.5.73-6.1.74s-12.02,5.2-12.02,5.2l-4.2,36.22,13.32,5.2h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.28,233.23s-3.62-3.5-1.22-6.38,22.98,1.54,22.98,1.54c0,0,12.54,2.16,14.01,4.85s1.99,2.69,1.99,2.69c0,0-.24-4.69-5.17-9.4,0,0-19.04-6.24-19.15-10.29s7.08-12.69,7.08-12.69l-10.25-10.29-21.78,22.76,3.9,13.39,7.61,3.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.78,274.45c-5.05-1.48.2-4.79,1.63-4.79,0,0,3.73,4.67,6.75,4.59s0,11.07,0,11.07c0,0-4.59-9.76-8.37-10.87h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.8,224.42l-13.01-2.05-4.22-15.49-7.61-15.31,15.7-3.49,9.29-13.65c-4.87,4.61-10.3,8.49-17.98,9.43l-11.78-6.87-.45-15.97,18.54-27.9s-2.25-17.44-6.83-21.19-7.32-16.88-7.32-16.88c0,0-2.19-1.58.94-6.03s.34-19.72.34-19.72l2.49-5.33c2.66-4.37,3.17-13.11,3.78-21.67-3.78-14.17-8.96-15.25-13.75-19.94l-15.38-6.76-2.81-3.97-7.68-.61-16.94-4.56s-16.54-3.42-35.15-1.89c-9.7.8-39.05,12.02-51.1,22.06-17.53,14.59-19.09,37.26-16.94,36.95l-9.04,4.78-1.76,10.68-2.63,2.34,9.71,17.48-3.6,7.29s-8.36,17.15-8.37,22.93c0,15.28,18.43,28.04,14.37,36.88l-4.06,4.04c-11.08,5.2-22.29,9.7-32.77.4,5.67,8.71,13.98,13.17,21.96,15.2l-8.24,15.47v19.23l-12.82,4.86-8.35,6.19-6.8,31.41,2.76,14.27s.46-13.11,4.63-21.88c4.16-8.77,7.14-11.45,12.79-11.45s11.87.72,13.98,7.27c2.11,6.54,1.6,32.49,3.39,43.05s17.46,47.9,16.78,51.79l7.18-4.84s4.69-5.82,16.56-5.76,26.75-2.77,26.75-2.77l-17.4-6.97-27.86,3.9-8.34-29.03-.68-20.31,11.96-2.99,1.77-36.1s23.15,2.66,33.79.17c0,0-15.1-9.41-15.91-13.11s-14.88-22.7-14.88-22.7c0,0,2.66,12.04,8.03,12.95,5.37.91,42.29,10.14,42.29,10.14,0,0-2.75-17.11,3.63-26.61s19.67-28.84,19.67-28.84c0,0,3.26,4.26,9.41,4.03,6.15-.23-4.38,16.98-.68,12.12,0,0-2.17,7.84.14,9.48s1.51.88,1.51.88h0l4.36-.92s13.71,9.93,13.71,12.61-6.56,8.08-6.56,8.08c0,0,3.49,1.71,8.45-.97,4.96-2.68,9.25-9.47,9.25-9.47l2.25,15.65-9.73,2.66-15.89,13.77,13.93,1.76,16.22-.04,2.42,33.75,6.34,3.99,1.62-22.21,6.03-8.77s7.3-.82,12.33-4.12c5.04-3.3,8.17-6.07,10.15-4.1,1.98,1.96,7.75,8.22,5.52,21.9-2.23,13.68-6.78,28.35-6.78,28.35l8.67-3.82,7.29,4.24,4.75-31.56-4.75-29.99-10.58-5.78v-.04ZM191.57,96.88l14.11,32.92-12.45,6.52,1.78,10.2-3.44,4.06-13.98,26.17-44.98-18.08-4.16-1.61-2.96-5.61s-4.46-9.3-4.31-12.88-1.81-7.87-4.19-10.67c-2.39-2.8-14.76-17.4-14.76-17.4l-2.01-14.94,13.46-15.54,11.67,4.84,4.87-12.26,21.24,1.48,14.92-5.19c15.08-14.73,22.65-18.04,28.94-19.41l6.85,17.96.99,12.16-11.6,17.28h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "226.5 303.83 236.89 307.82 238.73 302.49 235.96 301.01 226.5 303.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "225.45 327.99 230.86 332.35 231.38 328.34 225.45 327.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.41,358.19s8.52,11.82,15.22,12.85,116.12-22.71,131.6-31.48c0,0,21.68-2.43,34.84-5.35s12.24-4.05,12.24-4.05c0,0,1.3-7.27,2.18-7.27s9.46,2.63,11.13.5,1.04-6.75,1.04-6.75l-10.85-3.6s10.35,2.69,11.98,1.44,2.38-4.39,2.38-4.39l4.52,1.88-.96,6.15-3.18,8.15-5.25.65-3.35,7.28,2.44,3.23-2.44,3.14s-17.87,51.05-21.88,56.82-171.37-8.78-171.37-8.78l-10.28-30.44v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.34,291.76c.52,3.18-20,9.25-20,9.25l4.9,2.82,16.76-1.36,4.33-1.46-1.79-7.01-4.19-2.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.94,275.27s-1.59,3.64,0,10.05,2.66,11.43,2.66,11.43l-10.45.27s1.5-11.64,2.66-14.44,5.12-7.32,5.12-7.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.47,279.31l7.82,31.73,98.28,5.61,21.75-12.85-1.65-25.25s-38.79,22.13-61.52,20.09-64.68-19.33-64.68-19.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.15,305.7c-6.16,3.71-26.16,13.9-45.59,6.35s-16.05-18.9-15.47-33.5c0,0-5.47-1.54-9.52,2.02s7.07,46.85,7.07,46.85l27.31-3.86,20.03,9.52,15.35-2.26.83-25.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.61,305.7c6.16,3.71,26.16,13.9,45.59,6.35s16.05-18.9,15.47-33.5c0,0,5.47-1.54,9.52,2.02s-2.53,27.25-2.53,27.25l-26.89,14.92-23.89,3.95-16.49,2.7-.78-23.69h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "125.15 261.8 120.96 269.66 124.79 272.52 129.28 268.37 125.15 261.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.12,266.99s2.83,1.27,3.28,1.23l-.74-5.34-2.54,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.2,74.56s-5.33,12.83-4.96,17.12,9.86,15.9,10.26,21.44-4.02,12.45-5.18,20.01c-1.16,7.56-2.35,10.07,1.98,12.42s14.75,2.73,14.75,2.73c0,0-10.79-6.94-9.79-11.65s7.43-12.52,7.93-17.35-7.81-19.7-7.68-24.79,5.87-22.68,5.87-22.68l-13.18,2.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.3,63.57s-34.75,14.47-38.83,15.23-12.82,4.31-13.54,7.45-5.17,13.36-3.97,21.85-.6,27.26,4.13,32.97,11.27,10.77,11.27,10.77c0,0-7.86,4.73-13.97,3.92s7.08,7.89,10.68,11.94-42.41-9.03-42.41-9.03l8.53-30.78s11.87-4.71,9.26-14.77-1.44-37.43-1.44-37.43l52.45-37.9,19.69,16.14-1.84,9.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.6,101.83s2.83,10.18,3.9,12.76,7.4,6.29,7.4,6.29c0,0-5.91-5.41-5.92-8.59s1.34-14.32,1.34-14.32l-5.11-5.4s-1.61,9.26-1.61,9.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "153.3 91.93 153.3 95.56 156.42 97.53 158.35 91.16 153.3 91.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.57,135s-4.35-1.57-3.78-3.42,1.04-.8,2.17-.58c4.14.82,13.82-.86,13.82-.86l-12.22,4.86h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.07,156.28c-2.21-.87-5.76,0-5.76,0l5.76,1.42v-1.42Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.82,22.52s6.65-11.07,13.7-13.44c9.53-3.2,14.06-2.11,21.45-1.05,0,0-10.51,8.46-8.52,11.17s16.95-2.5,24.2-3.4c5.49-.67,7.84.32,7.84.32-1.42-.71-11.13,7.11-7.36,17.18,0,0,15.25.59,16.85,3.12,2.03,3.21-6.9,4.88-15.69,12.46-8.78,7.58-13.07,7.59-21.52,9.34,0,0,11.54-10.26,6.66-16.58s-27.01,1.68-27.01,1.68c0,0,5.82-11.83,14.22-16.28,12.69-6.73-18.46-8.47-24.82-4.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M199.22,95.23c-.35.93.6,1.19,1.44.66,7.23-4.57,9.26-14.74,8.11-17.44-1.25-2.92-3.31-7.52-3.31-7.52,0,0-3.19,12.36-3.78,16.61-.2,1.45-1.21,4.41-2.46,7.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.32,176.55c4.11-1.8,10.8,8.49,10.93,15.93s-.63,13.84-3.77,16.48-8.62,1.63-9.9-1.51,3.12-13.1,1.61-19.36-.88-10.66,1.13-11.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.39,80.26c-1.65-2.79,13.63-6.57,15.61-13.88s9.66-2.86,12.88-.94,2.35,8.62,0,10.23-22.42,14.87-28.49,4.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.56,95.56c-.33-2.92,20.54-3.78,23.39-7s5.96-4.21,7.75,0-7.26,11.87-16.18,11.32-14.19,2.43-14.96-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.04,126.06s13.86,0,17.08,9.89,5.21,21.99,7.55,22.72,8.55-11.11,9.24-17.03,6.47,5.81,6.68,21.9-17.95,33.15-26,34.05-.23-5.31-.46-12.43-10.1-2.99-19.19-3.45-21.48,3.44-21.97-1.38,21.18-5.64,21.97-18.46.44-32.82,5.1-35.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.25,100.08c3.53-5.35,14.94,7.97,15.94,14.51s-8.16,16.34-7.97,20.42-3.58,13.35-8.93,3.51c0,0,8.43-12.06,7.85-19.85s-6.89-18.59-6.89-18.59h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror_copy",
    "data-name": "Lines Mirror copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.56,169.29c-6.27,3.71-6.96,11.7-7.48,19.46-.38,5.72,1.25,11.64,1.28,18.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.88,93.37c2.52,23.23,26.16,27.35,5.48,51.66-19.2,22.57-9.06,37.31,1.85,37.05s16.84-9.94,16.84-9.94c0,0,.84,26.38-29.88,19.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.15,193.54s10.28,14.83,10.44,22.17c.2,9.4-1.22,20.22-17.86,23.06,0,0,13.45-7.24,4.57-19.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.93,209.86s-2.88,14.92-9.95,24.31c-6.36,8.45-33.45,14.84-43.22,5.86,0,0,15.36-7.13,17.71-14.82s4.17-20.91,1.82-26.67c0,0,2.65,10.78-2.53,17.24-3.78,4.73-9.6,8.29-17.72,6.53,0,0,9.05-3.77,7.77-13.9-1.69-13.37-10.85-10.56-12.79-19.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.57,223.55c-8.55,2.1-19.86,4.78-24.7,5.48-8.26,1.2-13.08,6.89-13.08,6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.05,197.59s6.51,7.67,4.51,16.38c-1.67,7.25-10,32.89-30.4,46.44,0,0,5.05,7.03,4.95,8.45-.21,2.77-3.04,5.47-4.95,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.94,343.21c-2.67,9.71-4.79,17.02-5.65,19.3,0,0-8.16,18.83-13.62,32.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.2,327.41c-.62,2.32-1.22,4.59-1.82,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.34,303.83c-.41,1.6-.82,3.21-1.24,4.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.38,291.76c3.59-14.47,6.26-26.16,6.4-29,.39-8.24-3.66-29.31-5.1-32.19s-7.72-6.15-7.72-6.15c0,0-12.8-2.65-16.16-3.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.2,250.96s-4.33,6.66-4.9,9.27c-1.78,8.17-2.28,31.34-4.79,45.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,298.02c24.56-.87,64.17-21,64.17-21l8.23,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.58,243.44s1.55,18.57,2.7,33.59h5.98s-2.09-29.24-3.54-34.95l-5.14,1.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.27,274.26s-4.72,4.33-6.54,7.25c-2.57,4.13-2.57,15.52-2.57,15.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.2,89.39l4.14,2.11s12.48-1.8,15.8-1.39,12.51,2.7,15.31,4.46c0,0-1.59-3.08-3.83-4.71-1.28-.93-10.89-5.01-10.89-5.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.97,95.56s5.92,5.53,9.92,4.72c9.44-1.9,16.29-1.32,16.29-1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.2,84.45c-.81-.62-13.3-5.19-16.76-6.31s-20.8-.53-21.05-.36c-.36.24,14.59.35,17.86,1.16s21.27,8.68,22.28,8.43c0,0-2.33-2.92-2.33-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.52,75s-10.66,14.12-2.45,28.56c3.94,6.93,5.76,14.7,4.13,17.56s-9.39,12.86-6.12,19.4,10.62,7.55,14.7,7.96c0,0-14.98,3.66-20.64-.4-5.99-4.29-8.35-8.99-6.31-14.92,2.04-5.92,9.6-12.05,6.53-21.03-3.06-8.98-6.87-8.41-9.47-17.57s4.8-20.02,4.8-20.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.7,88.43s-5.15-5.32-11.24-5.4-11.04,14.97-10.78,18.45,2.55,11.04,5.89,15.22,6.5,8.48,6.5,8.48c0,0,3.37,4.03,9.62,2.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.37,99.88c-2.61,16.09-23.71,26.22.02,53.01,10.65,12.03-6,22.88-16.91,22.62s-16.84-11.54-16.84-11.54c0,0,0,27.6,34.62,21.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.66,186.26s-10.34,12.27-7.83,27.09c1.23,7.24,5.32,25.33,27.11,26.83,0,0-13.01-9.77-9.74-19.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.18,211.45s8.39,20.73,18.86,26.07,34.7,11.48,43.03,3.58c0,0-16.2-8.38-18.4-16.11-3.75-13.14,2.57-24.52,4.92-30.28,0,0-1.32,17.08,3.85,23.54,3.78,4.73,18.56,11.9,26.68,10.14,0,0-13-7.69-10.94-20.28,4.27-26.11,22.68-22.11,24.43-49.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.67,224.99s10.5,2.84,18.76,4.04,13.08,6.89,13.08,6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.4,223.09c4.06,10.93,12.77,27.36,27.75,37.32,0,0-5.05,7.03-4.95,8.45.21,2.77,3.04,5.47,4.95,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.69,387.82C25.93,368.13,1.92,271,1.53,262.76s3.66-29.31,5.1-32.19c1.44-2.88,7.72-6.15,7.72-6.15,0,0,10.91-4.15,13.83-5.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.11,250.96s4.33,6.66,4.9,9.27c1.92,8.83,2.36,35.17,5.44,48.69s8.58,32.03,8.58,32.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,298.02c-24.56-.87-64.17-21-64.17-21l-8.23,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.29,241.1s-2.12,20.91-3.27,35.93h-5.98s2.3-30.21,3.75-35.93c0,0,5.5,0,5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.04,274.26s4.72,4.33,6.54,7.25c2.57,4.13,2.57,15.52,2.57,15.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.3,25.99s-8.13,3.56-15.31,8.93c-5.93,4.43-7.67,7.39-9.9,11.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.23,16.7s18.47-9.57,29.94-8.6c8.17.69,10.2,1.91,14.49,8.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.12,67.01s5.63-17.61-8.36-17.61-16,9.45-23.21,14.68c-11.06,8.01-18.3,10.4-33.59,10.48-40.71.22-49.62-19.08-46.78-41.26,0,0,7.33,18.97,17.34,20.85,14.72,2.77,26.17-1.97,26.17-1.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.84,133.13c3.3,7.89-.78,20.13-9.27,20.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.7,52.08c10.08,9.65,14.16,26.89,11.3,35.97s-7.58,13.21-10.79,26.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.81,60.83c-4.51-13.97,13.06-36.36,36.46-47.94C111.66,1.32,152.96-2.22,168.49,7.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.04,21.05c54.95-19.33,53.95,39.37,41.2,46.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.04,344.29s15.69-7.77,21.91-7.99,74.81-8.44,90.58-15.1c0,0,2.94.6,8.41-2.38s31.29-25.36,31.29-25.36c0,0,14.03-.94,23.7-4.46,0,0,10.43,4.14,10.93,5.63s-.33,6.13,0,7.62-5.14,4.57-6.51,1.57c-.86-1.88-.84-4.44-4.32-3.78s-11.74,4.03-11.74,4.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.35,311.87c3.64,2.32,19.88,6.63,20.37,8.61,0,0,1.66-4.97,1.66-6.79s-2.15-3.64-8.28-5.47-16.56-6.63-16.56-6.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.72,320.48c0,6.46-2.32,7.78-4.67,6.96s-12.76-.66-12.76-.66c0,0,3.19,4.8,6.66,6.96s2.94,4.97,2.05,7.29-10-1.16-11.49-1.16-26.5,8.94-40.91,5.63c0,0-91.97,33.9-112.62,38.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.24,352.14s-6.98-5.93-21.86-4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.36,332.43s-13.95-7.18-17.4-7.88-23.49,3.59-28.48,3.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.1,148.18c-6.81-1.57-21.47,1.82-21.47,1.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.73,51.12s6.77,13.27,6.44,23.39-12.2,18.43-12.2,22.05,12.63,28.75,14.6,31.54-13.03,7.68-13.03,7.68c0,0-.49,4.56,1.58,8.58s-3.55,4.52-3.55,4.52c0,0,.55,1.86.55,4.3s-3.66.46-9.41,17.17c-2.36,5.95-8.55,3.67-8.55,3.67l-43.71-16.95-7.27-27.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.97,91.68s-.6,2.35,0,3.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.52,91.68s0,6.28-3.42,6.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110,102s-1.21-10.24,2.69-10.32,7.75,4.4,6.98,13.14-1.2,6.6-.77,8.74c.63,3.14,5.48,3.66,5.26,7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.09,78.81c-1.74-5.09,3.09-17.08,9.01-15.72s34.28-11,34.28-11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.31,80.59s-20.85,14.21-32.04,10.8-17.35-12.82-19.51-12.58.78,10.85,4.83,15.77,12.71,12.46,25.04,11.7,27.88-11.11,33.04-11.22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasminegreet);
export default __webpack_public_path__ + "static/media/jasmine greet.04191f0aa0b04cf9311dbd3145e7cf95.svg";
export { ForwardRef as ReactComponent };